/*@ngInject*/
const RefreshLoginTokenUtil = function ($q, $interval, coreConstant, preferenceModel, authenticationMediator) {

    let refreshInterval = coreConstant.DEFAULT_REFRESH_LOGIN_TOKEN_INTERVAL,
        intervalObject = null;

    this.start = (loginToken) => {
        let refreshIntervalInMillisecondsPreference = preferenceModel.get('system.loginTokenRefreshIntervalInMilliseconds'),
            refreshLoginTokenPromise;
        if (!isNaN(refreshIntervalInMillisecondsPreference)) {
            refreshInterval = _.parseInt(refreshIntervalInMillisecondsPreference);
        }

        if (!_.isNil(intervalObject)) {
            return $q.when();
        }

        // Make an immediate call to refresh the token, then start the interval.
        refreshLoginTokenPromise = authenticationMediator.refreshLoginToken(loginToken);
        intervalObject = $interval(() => {
            authenticationMediator.refreshLoginTokenWithCurrent();
        }, refreshInterval);

        return refreshLoginTokenPromise;
    };

    this.stop = () => {
        if (!_.isNil(intervalObject)) {
            $interval.cancel(intervalObject);
            intervalObject = null;
        }
    };
};

angular.module('gw-um-auth')
    .service('refreshLoginTokenUtil', RefreshLoginTokenUtil);
